import React from "react";
import { Twitter, Instagram } from "lucide-react";
import logo from "../assets/images/logo.jpg"; // replace with your logo
import { Link } from "react-router-dom"; // Make sure to import Link

function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-16 pb-8">
      <div className="w-4/5 mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Brand Section */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <img src={logo} alt="Logo" className="w-12 h-12 rounded-lg" />
            <h2 className="text-lg sm:text-2xl md:text-2xl font-bold text-white">
              Dotti Verify
            </h2>
          </div>
          <p className="text-gray-400 text-m sm:text-base md:text-lg leading-relaxed">
            The smartest way to verify identities, pay bills, and build trust
            online. Secure, fast, and reliable.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-white font-semibold text-lg sm:text-2xl md:text-xl mb-4">
            Quick Links
          </h3>
          <ul className="space-y-3 text-m sm:text-base md:text-lg">
            <li>
              <a href="/" className="hover:text-[#007AFF] transition">
                Home
              </a>
            </li>
            <li>
              <a href="/about" className="hover:text-[#007AFF] transition">
                About
              </a>
            </li>
            <li>
              <a href="/services" className="hover:text-[#007AFF] transition">
                Services
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:text-[#007AFF] transition">
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-white font-semibold text-lg sm:text-2xl md:text-xl mb-4">
            Our Services
          </h3>
          <ul className="space-y-3 text-m sm:text-base md:text-lg">
            <li>Electricity Bills</li>
            <li>Airtime & Data</li>
            <li>Cable TV Subscriptions</li>
            <li>Internet Bills</li>
          </ul>
        </div>

        {/* Socials */}
        <div>
          <h3 className="text-white font-semibold text-lg sm:text-2xl md:text-xl mb-4">
            Follow Us
          </h3>
          <div className="flex gap-5 mb-6">
            <a
              href="https://x.com/dveriy24104?s=21"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-[#007AFF] transition"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a
              href="https://www.instagram.com/dotti_verify?igsh=MTRjNHFiOGFoY2hidg%3D%3D&utm_source=qr"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-[#007AFF] transition"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
          <p className="text-gray-400 text-m sm:text-base md:text-lg">
            Stay connected with us for updates and offers.
          </p>
        </div>
      </div>

      {/* Bottom Bar with Privacy & Terms */}
      <div className="border-t border-gray-700 mt-12 pt-6">
        <div className="w-4/5 mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <p className="text-gray-500 text-base order-2 md:order-1">
            © {new Date().getFullYear()} Dotti Verify. All rights reserved.
          </p>

          {/* Privacy & Terms Links */}
          <div className="flex gap-6 order-1 md:order-2">
            <Link
              to="/privacypolicy"
              className="text-gray-400 hover:text-[#007AFF] transition text-base"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-600">|</span>
            <Link
              to="/TermsOfServices"
              className="text-gray-400 hover:text-[#007AFF] transition text-base"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
